import { useMemo } from "react";
import { useSelector } from "react-redux";

const useRoles = () => {
  const role = useSelector((state) => state.auth?.user?.role);

  const roles = useMemo(() => {
    if (!role) {
      return {
        readOnly: false,
        readWrite: false,
        admin: false
      };
    }

    return {
      readOnly: role === "READONLY",
      readWrite: role === "READWRITE",
      admin: role === "ADMIN"
    };
  }, [role]);

  return roles;
};

export default useRoles;
